import moment from "moment";

/*
 * get two date (start and end) as parameters
 * return true if start < end (less) else false
 */
export const isBefore = (start, end) => {
  return moment(start).isBefore(end); // true
};
export const isSameOrBefore = (start, end) => {
  return moment(start).isSameOrBefore(end); // true
};
export const isAfter = (start, end) => {
  return moment(start).isAfter(end); // true
};
/*
 * get two date (start and end) as parameters
 * return true if start >= end (less) else false
 */
export const isSameOrAfter = (start, end) => {
  return moment(start).isSameOrAfter(end); // true
};

/*
 * get 3 date (date,start and end) as parameters
 * return true if date lie bw start and end else flas
 */
export const isBetween = (date, start, end) => {
  return moment(date).isBetween(start, end, undefined, "[]"); // true
};

export const YYYYMMDDFormat = (date) => {
  return moment(date).format("YYYY-MM-DD"); // true
};

export const YYYYMMDDHHMMAFormat = (date) => {
  return moment(date).format("YYYY-MM-DD hh:mm A"); // true
};

export const DDMMYYYYHHMMAFormat = (date) => {
  return moment(date).format("DD-MM-YYYY hh:mm A"); // true
};

export const DDMMYYYYFormat = (date) => {
  return date ? moment(date).format("DD-MM-YYYY") : moment().format("DD-MM-YYYY"); // true
};

export const startDateValidation = (current, endDate) =>
  endDate ? isSameOrBefore(current, YYYYMMDDFormat(endDate)) : true;

export const endDateValidation = (current, startDate) =>
  startDate ? isSameOrAfter(current, YYYYMMDDFormat(startDate)) : false;

export const disablePastDate = (date) => {
  return date.isSameOrAfter(YYYYMMDDFormat());
};

export const disableFutureDate = (date) => {
  return date.isSameOrBefore(YYYYMMDDFormat());
};

export const disable12MonthAfterFutureDate = (date) => {
  return date.isSameOrBefore(nextYearDateDate());
};

export const nextMonthLastDate = () => {
  return moment().add(1, "M").endOf("month");
};

export const nextYearDateDate = () => {
  return moment().add(1, "Y").format("YYYY-MM-DD");
};

export const vflScheduledDate = (date) => {
  return isBetween(
    date,
    moment().subtract(1, "days"),
    moment().add(1, "M").endOf("month")
  );
};
